import { Link } from 'react-router-dom';

interface ArticleCard {
  title: string;
  desc: string;
  link: string;
  imageUrl: string;
}

const articles: ArticleCard[] = [
  {
    title: 'Yoybuy Spreadsheet — полное руководство 2026',
    desc: 'Узнайте, как использовать Yoybuy Spreadsheet для заказа товаров из Китая. Пошаговое руководство для новичков.',
    link: '/article/yoybuy-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20warm%20toned%20workspace%20with%20laptop%20displaying%20organized%20spreadsheet%20data%20on%20screen%20soft%20natural%20window%20lighting%20clean%20desk%20with%20ceramic%20coffee%20cup%20warm%20beige%20and%20cream%20aesthetic%20editorial%20product%20photography%20peaceful%20productive%20atmosphere%20no%20people&width=600&height=600&seq=yoybuy-art-v2-01&orientation=squarish'
  },
  {
    title: 'Yoybuy vs Kakobuy vs Superbuy — сравнение',
    desc: 'Детальное сравнение трёх популярных систем заказа из Китая. Какой агент лучше в 2026 году?',
    link: '/article/yoybuy-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20three%20neatly%20wrapped%20parcel%20boxes%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20product%20photography%20elegant%20packaging%20comparison%20concept%20soft%20beige%20background%20no%20text%20no%20people&width=600&height=600&seq=yoybuy-art-v2-02&orientation=squarish'
  },
  {
    title: 'Как заказать с Taobao через spreadsheet',
    desc: 'Практическое руководство по заказу товаров с Taobao через Yoybuy Spreadsheet систему.',
    link: '/article/yoybuy-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20sneakers%20and%20minimalist%20accessories%20flat%20lay%20on%20warm%20cream%20surface%20soft%20natural%20light%20editorial%20product%20photography%20clean%20composition%20with%20canvas%20shoes%20watch%20and%20sunglasses%20warm%20beige%20tones%20no%20people&width=600&height=600&seq=yoybuy-art-v2-03&orientation=squarish'
  },
  {
    title: 'Yoybuy Sheet — быстрый старт для новичков',
    desc: 'Первые шаги в Yoybuy Spreadsheet. Как настроить таблицу и сделать первый заказ за 10 минут.',
    link: '/article/yoybuy-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20desk%20setup%20with%20tablet%20displaying%20interface%20and%20notebook%20on%20cream%20surface%20soft%20natural%20lighting%20clean%20editorial%20style%20organized%20workspace%20with%20pencil%20warm%20beige%20aesthetic%20peaceful%20atmosphere%20no%20people&width=600&height=600&seq=yoybuy-art-v2-04&orientation=squarish'
  },
  {
    title: 'Доставка из Китая через Yoybuy — все способы',
    desc: 'Обзор всех способов доставки через Yoybuy Spreadsheet. Сравнение стоимости и сроков.',
    link: '/article/yoybuy-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20shipping%20logistics%20concept%20with%20neatly%20wrapped%20brown%20paper%20parcels%20tied%20with%20natural%20twine%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20product%20photography%20minimalist%20composition%20soft%20beige%20background%20no%20people&width=600&height=600&seq=yoybuy-art-v2-05&orientation=squarish'
  },
  {
    title: 'Yoybuy Spreadsheet vs традиционные агенты',
    desc: 'Почему табличная система эффективнее классических агентов? Полный разбор преимуществ Yoybuy Sheet.',
    link: '/article/yoybuy-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20digital%20tablet%20beside%20traditional%20paper%20forms%20on%20warm%20cream%20desk%20surface%20soft%20natural%20lighting%20editorial%20product%20photography%20contrast%20between%20digital%20and%20analog%20warm%20beige%20tones%20clean%20composition%20no%20people&width=600&height=600&seq=yoybuy-art-v2-06&orientation=squarish'
  },
  {
    title: 'Экономия с Yoybuy Sheet — сколько можно сберечь',
    desc: 'Реальные расчёты экономии при использовании Yoybuy Spreadsheet. Сравнение цен и комиссий.',
    link: '/article/yoybuy-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20financial%20savings%20concept%20with%20glass%20jar%20filled%20with%20coins%20beside%20calculator%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20product%20photography%20minimalist%20composition%20warm%20beige%20aesthetic%20no%20people&width=600&height=600&seq=yoybuy-art-v2-07&orientation=squarish'
  },
  {
    title: 'Пошаговый гид по 1688 через Yoybuy Sheet',
    desc: 'Как заказывать товары оптом с 1688 используя Yoybuy Spreadsheet. Полная инструкция.',
    link: '/article/yoybuy-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20wholesale%20product%20samples%20neatly%20arranged%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20product%20photography%20fabric%20swatches%20and%20small%20items%20organized%20clean%20composition%20warm%20beige%20tones%20no%20people&width=600&height=600&seq=yoybuy-art-v2-08&orientation=squarish'
  },
  {
    title: 'Yoybuy Spreadsheet для бизнеса — полный обзор',
    desc: 'Как предприниматели используют Yoybuy Sheet для масштабирования закупок из Китая.',
    link: '/article/yoybuy-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20business%20workspace%20with%20laptop%20showing%20analytics%20dashboard%20on%20warm%20cream%20desk%20soft%20natural%20lighting%20editorial%20product%20photography%20coffee%20cup%20and%20organized%20notes%20warm%20beige%20aesthetic%20no%20people&width=600&height=600&seq=yoybuy-art-v2-09&orientation=squarish'
  },
  {
    title: 'Отзывы о Yoybuy Sheet — реальный опыт 2026',
    desc: 'Собрали реальные отзывы пользователей Yoybuy Spreadsheet. Честные мнения и результаты.',
    link: '/article/yoybuy-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Happy%20customer%20unboxing%20experience%20with%20neatly%20opened%20parcel%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20product%20photography%20hands%20holding%20product%20tissue%20paper%20warm%20beige%20tones%20natural%20light%20no%20face%20visible&width=600&height=600&seq=yoybuy-art-v2-10&orientation=squarish'
  },
  {
    title: 'Как выбрать размер через Yoybuy Spreadsheet',
    desc: 'Полный гид по выбору размеров одежды и обуви при заказе из Китая через Yoybuy Sheet.',
    link: '/article/yoybuy-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Measuring%20tape%20and%20neatly%20folded%20clothing%20items%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20product%20photography%20tailor%20concept%20with%20ruler%20and%20fabric%20samples%20warm%20beige%20tones%20clean%20composition%20no%20people&width=600&height=600&seq=yoybuy-art-v2-11&orientation=squarish'
  },
  {
    title: 'Секреты быстрой доставки через Yoybuy',
    desc: 'Проверенные способы ускорить доставку из Китая при использовании Yoybuy Spreadsheet.',
    link: '/article/yoybuy-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fast%20delivery%20express%20shipping%20concept%20with%20cardboard%20box%20and%20tracking%20label%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20product%20photography%20speed%20and%20logistics%20theme%20warm%20beige%20tones%20no%20people&width=600&height=600&seq=yoybuy-art-v2-12&orientation=squarish'
  },
  {
    title: 'Yoybuy Sheet — ответы на частые вопросы',
    desc: 'FAQ по Yoybuy Spreadsheet: стоимость, доставка, возвраты, гарантии и другие важные темы.',
    link: '/article/yoybuy-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20organized%20desk%20with%20open%20notebook%20showing%20question%20marks%20and%20checklist%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20product%20photography%20FAQ%20concept%20minimalist%20composition%20warm%20beige%20tones%20no%20people&width=600&height=600&seq=yoybuy-art-v2-13&orientation=squarish'
  },
  {
    title: 'Полный обзор Yoybuy Spreadsheet 2026 года',
    desc: 'Все функции и возможности Yoybuy Sheet в одном обзоре. Что нового появилось в системе.',
    link: '/article/yoybuy-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20laptop%20with%20detailed%20spreadsheet%20interface%20displayed%20on%20screen%20warm%20cream%20desk%20setting%20soft%20natural%20lighting%20editorial%20product%20photography%20overview%20concept%20clean%20composition%20warm%20beige%20aesthetic%20no%20people&width=600&height=600&seq=yoybuy-art-v2-14&orientation=squarish'
  },
];

export default function ArticlePreview() {
  return (
    <section className="relative w-full py-24 md:py-32 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950"
            style={{ fontFamily: 'var(--font-heading)' }}>
            Статьи и гиды
          </h2>
          <p className="text-sm text-foreground-500 font-light mt-1 md:mt-0">
            Полезные материалы о Yoybuy Spreadsheet
          </p>
        </div>

        <div className="flex gap-4 md:gap-5 overflow-x-auto pb-4 -mx-6 px-6 scrollbar-hide">
          {articles.map((article, index) => (
            <Link
              key={index}
              to={article.link}
              className="flex-shrink-0 w-[240px] sm:w-[260px] md:w-[280px] group cursor-pointer"
            >
              <div className="rounded-2xl overflow-hidden bg-white border border-background-200/50 hover:border-background-300/80 transition-all duration-300">
                <div className="w-full h-[180px] sm:h-[200px] md:h-[220px] overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={article.title}
                    loading="lazy"
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <p className="font-label text-[11px] text-foreground-400 mb-1.5">
                    Руководство
                  </p>
                  <h4 className="font-heading text-sm md:text-base font-medium text-foreground-900 leading-snug mb-2"
                    style={{ fontFamily: 'var(--font-heading)' }}>
                    {article.title}
                  </h4>
                  <p className="text-xs text-foreground-500 font-light leading-relaxed line-clamp-2 mb-3">
                    {article.desc}
                  </p>
                  <span className="inline-flex items-center gap-1 text-xs md:text-sm font-label text-primary-500 group-hover:gap-2 transition-all duration-300">
                    Читать
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-xs md:text-sm"></i>
                    </div>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}